import React, {useRef, useEffect} from "react";
import PropTypes from "prop-types";
import scaleByWindow from "../EditorApp/decorators/scaleByWindow";

function ThreeDViewer(props) {
  const {enable, disable, className} = props;
  const threeDEl = useRef(null);
  useEffect(() => {
    enable(threeDEl.current);
    return () => {
      disable();
    };
  }, [disable, enable]);
  return (
    <div
      className={className}
      style={{
        width: `600px`,
        height: `600px`
      }}
      ref={threeDEl}
    />
  );
}

ThreeDViewer.propTypes = {
  className: PropTypes.string,
  enable: PropTypes.func,
  disable: PropTypes.func
};

export default scaleByWindow({width: 600, height: 600})(ThreeDViewer);
